export class ValidationErrorCodes {

  public static readonly ErrorCodes: {[code: string]: string} = {
    unknownField: 'MM.fault.import.errorCodes.unknownField',
    notPermittedField: 'MM.fault.import.errorCodes.notPermittedField',
    fieldSystemGenerated: 'MM.fault.import.errorCodes.fieldSystemGenerated',
    mandatoryStructureFieldMissing: 'MM.fault.import.errorCodes.mandatoryStructureFieldMissing',
    defaultStructure: 'MM.fault.import.errorCodes.defaultStructure',
    mandatoryFieldMissing: 'MM.fault.import.errorCodes.mandatoryFieldMissing',
    mandatoryFieldEmpty: 'MM.fault.import.errorCodes.mandatoryFieldEmpty',
    fieldMaxLengthExceeded: 'MM.fault.import.errorCodes.fieldMaxLengthExceeded',
    fieldMinValueExceeded: 'MM.fault.import.errorCodes.fieldMinValueExceeded',
    fieldMaxValueExceeded: 'MM.fault.import.errorCodes.fieldMaxValueExceeded',
    fieldTypeMismatch: 'MM.fault.import.errorCodes.fieldTypeMismatch',
    entityNotFound: 'MM.fault.import.errorCodes.entityNotFound',
    entityNotUnique: 'MM.fault.import.errorCodes.entityNotUnique',
    attachmentNotFound: 'MM.fault.import.errorCodes.attachmentNotFound',
    attachmentNotUniqueMatched: 'MM.fault.import.errorCodes.attachmentNotUniqueMatched',
    attachmentNotFoundOrNotUniqueMatched: 'MM.fault.import.errorCodes.attachmentNotFoundOrNotUniqueMatched',
    activityDateMissing: 'MM.fault.import.errorCodes.activityDateMissing',
    activityDateMinValueExceeded: 'MM.fault.import.errorCodes.activityDateMinValueExceeded',
    activityDateMaxValueExceeded: 'MM.fault.import.errorCodes.activityDateMaxValueExceeded',
    activityDateTypeMismatch: 'MM.fault.import.errorCodes.activityDateTypeMismatch',
    activityDeadlineMinValueExceeded: 'MM.fault.import.errorCodes.activityDeadlineMinValueExceeded',
    activityDeadlineMaxValueExceeded: 'MM.fault.import.errorCodes.activityDeadlineMaxValueExceeded',
    activityDeadlineTypeMismatch: 'MM.fault.import.errorCodes.activityDeadlineTypeMismatch',
    activityDeadlineToDateInvalidValue: 'MM.fault.import.errorCodes.activityDeadlineToDateInvalidValue',
    activityStatusMissing: 'MM.fault.import.errorCodes.activityStatusMissing',
    activityStatusNotFound: 'MM.fault.import.errorCodes.activityStatusNotFound',
    activityMaxDescriptionLengthExceeded: 'MM.fault.import.errorCodes.activityMaxDescriptionLengthExceeded',
    activityAttachmentNotFound: 'MM.fault.import.errorCodes.activityAttachmentNotFound',
    activityAttachmentNotUniqueMatched: 'MM.fault.import.errorCodes.activityAttachmentNotUniqueMatched',
    activityAttachmentNotFoundOrNotUniqueMatched: 'MM.fault.import.errorCodes.activityAttachmentNotFoundOrNotUniqueMatched'
  };

}
